<script>
    import {onMount} from 'svelte'
    import {swipe} from 'svelte-gestures';
    let slidePos = 3
    const plusPos = (ev)=>{
        if(slidePos<6) slidePos += 1
        else slidePos = 0
    }
    const minusPos = ()=>{
        if(slidePos>0) slidePos -= 1
        else slidePos = 6
    }
    const handler = (ev)=>{
        if(ev.detail.direction === "left"){
            minusPos()
        }else if(ev.detail.direction === "right"){
            plusPos()
        }
    }
    const data = [
        {
            img:"/img/people_img2.png",
            txt1:"【訪問販売・30代】",
            txt2:"愛用サイズ　小さいサイズ",
            txt3:"人工シルクの肌触り",
            txt4:"お客様に直接お会いする仕事なので一日中マスクをつけていますが、肌触りが良いので苦になりません。\nこのマスクは長時間付けていても匂いもほとんど付かないし、マスクの毛羽立ちもないので夕方になっても安心ですね。"
        },
        {
            img:"/img/people_img3.png",
            txt1:"【歯科受付・30代】",
            txt2:"愛用サイズ　小さいサイズ",
            txt3:"通気性がよく、\n会話がしやすい",
            txt4:"長時間装着しますが、ゴムひもによる耳の痛みもなく快適に使用しています。\n通気性がよく、声が通りやすいので、\n患者様との会話がしやすいのも良いですね。"
        },
        {
            img:"/img/people_img.png",
            txt1:"【エステティシャン・30代】",
            txt2:"愛用サイズ　小さいサイズ",
            txt3:"ヒアルロン酸配合は\n肌に優しい",
            txt4:"隙間なくフィットして、耳掛け部分が柔らかので、長時間つけていても痛くないですね。\n肌にも優しく、施術中でも呼吸が楽です。\nお客様との距離が近いので、隙間なくフィットするこのマスクは安心して使えます。"
        },
        {
            img:"/img/people_img1.png",
            txt1:"【歯科助手・30代】",
            txt2:"愛用サイズ　小さいサイズ",
            txt3:"不安感ゼロと安心感\nの両立",
            txt4:"こだわりの3層構造は、不安感がなくとても安心です。\n肌にも優しく、診療中でも呼吸が楽です。\n長時間つけていても苦にならないです。"
        },
        {
            img:"/img/people_img5.png",
            txt1:"【トリマー・30代】",
            txt2:"愛用サイズ　小さいサイズ",
            txt3:"耳が痛くならないの\nが嬉しい",
            txt4:"長時間付けていてもストレスを感じないし、\n耳も痛くならないです。肌に優しくて、通気性が良いのも嬉しいで\nすね。"
        },
        {
            img:"/img/people_img4.png",
            txt1:"【保育士・30代】",
            txt2:"愛用サイズ　小さいサイズ",
            txt3:"抜群の通気性で\n会話も安心",
            txt4:"小さいお子様と対面するので、マスクは常に着用しています。\n耳が痛くならないのと、呼吸も苦しくないので愛用しています。つけ心地もとてもフィットするので最高です。"
        },
        {
            img:"/img/people_img6.png",
            txt1:"【介護士・20代】",
            txt2:"愛用サイズ　小さいサイズ",
            txt3:"肌のトラブルを防ぐ\nヒアルロン酸",
            txt4:"このマスクを使い始めてから、ほとんど肌荒れしません。優しい付け心地もとても気に入っています。お年寄りの方を相手にする仕事中はずっとマスクをつけているので、この肌荒れの起こりにくさと肌触りの良さは重要です。"
        },
    ]
</script>
<div class="slider">
    <div class="slide-wrapper">
        <div class="slider-main" use:swipe={{ timeframe: 300, minSwipeDistance: 60,touchAction: 'pan-y'  }} on:swipe={handler}>
            <div class="slide {(slidePos - 1) == 0 ? "grad-left" : ""}  {slidePos === 0 ? 'active' : ''}" >
                <div class="slide-inner">
                    <img src="{data[0].img}" alt="">
                    <p class="txt1">{data[0].txt1}</p>
                    <p class="txt3">{data[0].txt3}</p>
                    <p class="txt4">{data[0].txt4}</p>
                </div>
            </div>
            <div class="slide {slidePos == 0 ? "grad-right" : ""} {slidePos == 2 ? "grad-left" : ""} {slidePos === 1 ? 'active' : ''}">
                <div class="slide-inner">
                    <img src="{data[1].img}" alt="">
                    <p class="txt1">{data[1].txt1}</p>
                    <p class="txt3">{data[1].txt3}</p>
                    <p class="txt4">{data[1].txt4}</p>
                </div>
            </div>
            <div class="slide {slidePos < 2 ? "grad-right" : ""} {slidePos === 2 ? 'active' : ''}">
                <div class="slide-inner">
                    <img src="{data[2].img}" alt="">
                    <p class="txt1">{data[2].txt1}</p>
                    <p class="txt3">{data[2].txt3}</p>
                    <p class="txt4">{data[2].txt4}</p>
                </div>
            </div>

            <div class="slide {(slidePos - 1) == 3 ? "grad-left" : ""} {(slidePos + 1) == 3 ? "grad-right" : ""} {slidePos === 3 ? 'active' : ''}">
                <div class="slide-inner">
                    <img src="{data[3].img}" alt="">
                    <p class="txt1">{data[3].txt1}</p>
                    <p class="txt3">{data[3].txt3}</p>
                    <p class="txt4">{data[3].txt4}</p>
                </div>
            </div>
            <div class="slide {(slidePos - 1) == 4 ? "grad-left" : ""} {(slidePos + 1) == 4 ? "grad-right" : ""} {slidePos === 4 ? 'active' : ''}">
                <div class="slide-inner">
                    <img src="{data[4].img}" alt="">
                    <p class="txt1">{data[4].txt1}</p>
                    <p class="txt3">{data[4].txt3}</p>
                    <p class="txt4">{data[4].txt4}</p>
                </div>
            </div>
            <div class="slide {(slidePos - 1) == 5 ? "grad-left" : ""} {(slidePos + 1) == 5 ? "grad-right" : ""} {slidePos === 5 ? 'active' : ''}">
                <div class="slide-inner">
                    <img src="{data[5].img}" alt="">
                    <p class="txt1">{data[5].txt1}</p>
                    <p class="txt3">{data[5].txt3}</p>
                    <p class="txt4">{data[5].txt4}</p>
                </div>
            </div>
            <div class="slide {(slidePos - 1) == 6 ? "grad-left" : ""} {(slidePos + 1) == 6 ? "grad-right" : ""} {slidePos === 6 ? 'active' : ''}">
                <div class="slide-inner">
                    <img src="{data[6].img}" alt="">
                    <p class="txt1">{data[6].txt1}</p>
                    <p class="txt3">{data[6].txt3}</p>
                    <p class="txt4">{data[6].txt4}</p>
                </div>
            </div>
    </div>

    </div>

    <div class="slide-btn">
        <img src="/img/right_btn.svg" on:click={minusPos} alt="">
        <img src="/img/left_btn.svg" on:click={plusPos} alt="">
        <ul>
            <li class="{slidePos === 0 ? "active" : ""}" on:click={()=>{slidePos = 0}}></li>
            <li class="{slidePos === 1 ? "active" : ""}" on:click={()=>{slidePos = 1}}></li>
            <li class="{slidePos === 2 ? "active" : ""}" on:click={()=>{slidePos = 2}}></li>
            <li class="{slidePos === 3 ? "active" : ""}" on:click={()=>{slidePos = 3}} ></li>
            <li class="{slidePos === 4 ? "active" : ""}" on:click={()=>{slidePos = 4}}></li>
            <li class="{slidePos === 5 ? "active" : ""}" on:click={()=>{slidePos = 5}}></li>
            <li class="{slidePos === 6 ? "active" : ""}" on:click={()=>{slidePos = 6}}></li>
        </ul>
    </div>

</div>
<style>
    p{
        margin:0;
    }
    .slider{
        display: flex;
        width:100%;
        height:640px;
        padding-bottom: 20px;
        position: relative;
    }
    .slide-wrapper{
        display: flex;
        width:100%;
        height:100%;
        position: relative;
    }
    .slider-main{
        position: relative;
        display: flex;
        justify-content: space-between;
        width:100%;
        transition:transform .5s;
    }
    .slide{
        width: 360px;
        height: 466px;
        opacity:0;
        position:absolute;
        left:50%;
        transform:translateX(-50%);
    }
    .slide-inner{
        margin: auto;
        width:320px;
        height: 466px;
        padding-bottom: 20px;
        border-radius: 5px;
        background: #fcfcfc;
        box-shadow: 0px 6px 20px rgba(51, 49, 45, 0.13);
    }
    .slide-inner img{
        margin: auto;
        padding-top: 36px;
        display: block;
        width: 176px;
    }
    .slide-inner .txt1{
        margin-top: 12px;
        font-family: "Noto Serif JP";
        font-weight: bold;
        font-size: 14px;
        letter-spacing: 0.06em;
        text-align: center;
        color: #433a2c;
    }
    .slide-inner .txt2{
        font-family: "Noto Serif JP";
        font-weight: bold;
        font-size: 12px;
        letter-spacing: 0.06em;
        text-align: center;
        color: #433a2c;
    }
    .slide-inner .txt3{
        font-family: "Noto Serif JP";
        font-weight: bold;
        font-size: 22px;
        letter-spacing: 0.06em;
        text-align: center;
        color: #b29a74;
        margin-left: 24px;
        margin-top: 12px;
        white-space: pre-line;
    }
    .slide-inner .txt4{
        font-family: "Noto Serif JP";
        font-weight: bold;
        font-size: 14px;
        letter-spacing: 0.06em;
        text-align: left;
        color: #433a2c;
        margin-top: 11px;
        margin-left: 24px;
        width:285px;
    }
    .slide.active{
        opacity:1;
        transition:opacity .5s;
    }
    .slide-btn{
        position: absolute;
        left:50%;
        top:106px;
        transform: translateX(-50%);
        width:90%;
        display: flex;
        justify-content: space-between;
    }
    .slide-btn img{
        width: 40px;
    }
    ul{
        position: absolute;
        display:flex;
        width:131px;
        justify-content: space-between;
        margin: auto;
        left: 45%;
        transform: translateX(-50%);
        top: 400px;
    }
    li{
        width: 15px;
        height: 15px;
        background: #efefef;
        display: block;
        border-radius: 100%;
    }
    li.active{
        background:#B7A582;
    }
    @media screen and (max-width:640px){

    }
</style>